import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useCallback, useMemo } from 'react';
import JACK_MENU_BUTTON_IMAGE_URL from '../assets/jack-menu-button.png';
import { setDrawerOpenState } from '../redux/actions/drawerActions';
import { selectIsTourneyRoom } from '../redux/selectorFns';
import { useAppDispatch, useAppSelector } from '../redux/store';
import { DRAWER_BUTTON_HOVER_COLOR, DRAWER_EXPANDABLE_SECTION_HEADER_COLOR, RIGHT_PANEL_TOURNEY_ROOM_ACTIVE_BUTTON_BACKGROUND_COLOR, RIGHT_PANEL_TOURNEY_ROOM_BUTTON_HOVER_COLOR } from '../styles/colors';
const CLOSED_BUTTON_BACKGROUND_COLOR = '#303030';
const CLOSED_BUTTON_BORDER_COLOR = '#404040';
const CLOSED_BUTTON_HOVER_COLOR = CLOSED_BUTTON_BORDER_COLOR;
const OPEN_BUTTON_BACKGROUND_COLOR = DRAWER_EXPANDABLE_SECTION_HEADER_COLOR;
const OPEN_BUTTON_BORDER_COLOR = DRAWER_BUTTON_HOVER_COLOR;
const OPEN_BUTTON_HOVER_COLOR = DRAWER_BUTTON_HOVER_COLOR;
function getHoverBackgroundColor(isOpen, isTourneyRoom) {
    if (isOpen) {
        return OPEN_BUTTON_HOVER_COLOR;
    }
    return isTourneyRoom ? RIGHT_PANEL_TOURNEY_ROOM_ACTIVE_BUTTON_BACKGROUND_COLOR : CLOSED_BUTTON_HOVER_COLOR;
}
function getIconContainerBackgroundColor(isOpen, isTourneyRoom) {
    if (isOpen) {
        return OPEN_BUTTON_BACKGROUND_COLOR;
    }
    return isTourneyRoom ? RIGHT_PANEL_TOURNEY_ROOM_BUTTON_HOVER_COLOR : CLOSED_BUTTON_BACKGROUND_COLOR;
}
function getIconContainerBorderColor(isOpen, isTourneyRoom) {
    if (isOpen) {
        return OPEN_BUTTON_BORDER_COLOR;
    }
    return isTourneyRoom ? RIGHT_PANEL_TOURNEY_ROOM_ACTIVE_BUTTON_BACKGROUND_COLOR : CLOSED_BUTTON_BORDER_COLOR;
}
export const ToggleDrawerButton = ({ isOpen }) => {
    const isTourneyRoom = useAppSelector(selectIsTourneyRoom);
    const dispatch = useAppDispatch();
    const onClick = useCallback(() => {
        dispatch(setDrawerOpenState(!isOpen));
    }, [dispatch, isOpen]);
    const buttonCss = useMemo(() => css `
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0);
      border: none;
      padding: 3px;
      &:hover {
        .icon-container {
          background-color: ${getHoverBackgroundColor(isOpen, isTourneyRoom)};
        }
        img {
          filter: brightness(150%);
          transform: scale(115%);
        }
      }
    `, [isOpen, isTourneyRoom]);
    const iconContainerCss = useMemo(() => css `
      background-color: ${getIconContainerBackgroundColor(isOpen, isTourneyRoom)};
      border: 2px solid ${getIconContainerBorderColor(isOpen, isTourneyRoom)};
      border-radius: 50%;
      width: 48px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
    `, [isOpen, isTourneyRoom]);
    const title = isOpen ? 'Close Menu' : 'Open Menu';
    return (_jsx("button", { onClick: onClick, title: title, css: buttonCss, children: _jsx("div", { css: iconContainerCss, className: 'icon-container', children: _jsx("img", { src: JACK_MENU_BUTTON_IMAGE_URL, width: 40, height: 40 }) }) }));
};
